<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 34 34">
    <g id="dashboard-icon-off" transform="translate(-120 -300)">
      <g id="Rectángulo_18" data-name="Rectángulo 18" transform="translate(120 300)" fill="#fff" stroke="#707070" stroke-width="1" opacity="0">
        <rect width="36" height="36" stroke="none"/>
        <rect x="0.5" y="0.5" width="36" height="36" fill="none"/>
      </g>
      <path id="Icon_awesome-users" data-name="Icon awesome-users" d="M4.5,11.25a3,3,0,1,0-3-3A3,3,0,0,0,4.5,11.25Zm21,0a3,3,0,1,0-3-3A3,3,0,0,0,25.5,11.25Zm1.5,1.5H24a2.991,2.991,0,0,0-2.114.872,6.857,6.857,0,0,1,3.52,5.128H28.5a1.5,1.5,0,0,0,1.5-1.5v-1.5A3,3,0,0,0,27,12.75Zm-12,0A5.25,5.25,0,1,0,9.75,7.5,5.247,5.247,0,0,0,15,12.75Zm3.6,1.5h-.389a7.248,7.248,0,0,1-6.422,0H11.4A5.4,5.4,0,0,0,6,19.65V21a2.251,2.251,0,0,0,2.25,2.25h13.5A2.251,2.251,0,0,0,24,21V19.65A5.4,5.4,0,0,0,18.6,14.25ZM8.114,13.622A2.991,2.991,0,0,0,6,12.75H3a3,3,0,0,0-3,3v1.5a1.5,1.5,0,0,0,1.5,1.5H4.589A6.874,6.874,0,0,1,8.114,13.622Z" transform="translate(122 304.25)" :fill="colorx"/>
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'user',
    data: () => ({

    }),
    props: {
      colorx: {
        type: String,
        default: '#89899B'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/UserIcon.vue